<template>
    <div class="block-region">
        <div class="block-region__content">
            <div class="block-region__title">{{ goodTitle }}</div>
            <div class="block-region__info">Регион: {{ regionTitle }} ({{ progress }}%)</div>
            <button class="ui-btn block-region__btn" :class="{'block-region__btn--disabled': disabled}" @click="onUpgrade">
                Улучшить объявление
                <img src="@/assets/icons/check.svg" class="block-region__btn-icon" v-if="disabled">
            </button>
        </div>
        <div class="block-region__img" :class="`block-region__img--id-${goodId}`">
            <block-good-img class="block-region__img-img" :id="goodId" />
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            goodId: {
                type: Number,
                required: true
            },
            goodTitle: {
                type: String,
                default: ''
            },
            regionTitle: {
                type: String,
                default: ''
            },
            progress: {
                type: Number,
                default: 0
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onUpgrade () {
                if (!this.disabled) {
                    this.$emit('upgrade')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .block-region {
        display inline-flex
        background-color #3665F3
        padding 2.3rem 0 2.3rem 2.9rem
        color #fff
        box-sizing border-box
        width 100%
        position relative
        overflow hidden
        +layout-xxs() {
            padding 1.5rem
        }

        &__content {
            max-width 18rem
            +layout-sm() {
                max-width 100%
            }
        }

        &__title {
            font-size 2rem
            font-weight $font-bold
            +layout-sm() {
                font-size 1.5rem
            }
        }

        &__info {
            font-size 1.5rem
            margin-top 3px
            +layout-sm() {
                max-width 60%
            }
        }

        &__btn {
            min-height 4rem
            margin-top 2.2rem
            padding 1rem
            width 15rem
            font-size 1.5rem

            &--disabled {
                background-color #659EFF
                pointer-events none
                text-align left
                display flex
                justify-content space-between
                align-items center
            }
            &-icon {
                margin-left 0.8rem
                width 2.2rem
                height @width
                flex-shrink 0
            }
        }

        &__img {
            display flex
            position absolute
            right 0
            bottom 0

            &-img {
                width 100%
                max-width 100%

            }

            &--id-1 {
                right -3.7rem
                bottom -0.3rem
                +layout-sm() {
                    width 11.1rem
                }
                +layout-xs() {
                    bottom -2rem
                }
                +layout-xxs() {
                    right -4.2rem
                    bottom 0
                }
            }

            &--id-2 {
                right -3.6rem
                bottom 0
                +layout-sm() {
                    width 13rem
                    right 0.5rem
                }
                +layout-xs() {
                    right -2rem
                }
                +layout-xxs() {
                    right -4rem
                    bottom 0
                }
            }

            &--id-3 {
                right 1.5rem
                bottom 0
                +layout-sm() {
                    width 6rem
                }
                +layout-xxs() {
                    right 1.6rem
                }
            }

            &--id-4 {
                right -2.3rem
                bottom 0
                +layout-sm() {
                    width 12rem
                }
                +layout-xs() {
                    right -2rem
                }
                +layout-xxs() {
                }
            }

            &--id-5 {
                +layout-xxs() {
                    right -0.5rem
                }
            }

            &--id-6 {
                right -2.8rem
                bottom -0.1rem
                +layout-sm() {
                    right -3.4rem
                    bottom -0.6rem
                    width 11.8rem
                }
            }

            &--id-7 {
                +layout-sm() {
                    right -2.3rem
                    width 9.4rem
                    bottom 0
                }

            }
        }

    }
</style>
